import { useInitConsent } from "./overlays/Consent/useInitConsent";
import { useInitCustomBanner } from "./overlays/CustomBanner/useInitCustomBanner";
import { useInitAdjustBanner } from "./overlays/AdjustBanner/useInitAdjustBanner";
import { useInitAirship } from "./overlays/Airship/useInitAirship";
import { useInitGoogleOneTap } from "./overlays/GoogleOneTap/useInitGoogleOneTap";
export const useInitOverlayOrchestrator = () => {
    useInitConsent();
    useInitCustomBanner();
    useInitAdjustBanner();
    useInitGoogleOneTap();
    useInitAirship();
};
